// @/utils/gtmConsent.js
import { 
  hasConsent, 
  subscribeToConsentChanges,
  hasUserMadeChoice 
} from './cookieConsentUtil';

/**
 * Проверяет, готов ли GTM принимать команды
 */
const isGTMReady = () => {
  return typeof window !== 'undefined' && !!window.google_tag_manager;
};

/**
 * Инициализирует Google Consent Mode
 */
export const initializeGTMConsent = () => {
  if (typeof window === 'undefined') return;

  console.log('[GTM] Initializing Google Consent Mode');

  // Устанавливаем начальные настройки согласия
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  // Default consent settings
  window.gtag('consent', 'default', {
    'analytics_storage': 'denied',
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'functionality_storage': 'granted',
    'personalization_storage': 'denied',
    'security_storage': 'granted',
    'wait_for_update': 2500
  });
  
  // Запускаем интервальную проверку готовности GTM
  const checkInterval = setInterval(() => {
    if (isGTMReady() && hasUserMadeChoice()) {
      const analytics = hasConsent('analytics');
      const advertising = hasConsent('advertising');
      
      console.log('[GTM] Applying saved consent in interval check:', { analytics, advertising });
      const success = updateConsentState(analytics, advertising);
      
      if (success) {
        console.log('[GTM] Successfully applied consent settings');
        clearInterval(checkInterval);
      }
    }
  }, 100);
  
  // Очищаем интервал через 10 секунд в любом случае
  setTimeout(() => {
    clearInterval(checkInterval);
  }, 10000);
};

/**
 * Обновляет состояние согласия в GTM
 * @param {boolean} analytics - Разрешена ли аналитика
 * @param {boolean} advertising - Разрешена ли реклама
 * @returns {boolean} - Успешно ли выполнено обновление
 */
export const updateConsentState = (analytics, advertising) => {
  if (!isGTMReady()) return false;

  console.log('[GTM] Updating consent state:', { analytics, advertising });
  
  // Обновляем настройки согласия через gtag
  window.gtag('consent', 'update', {
    'analytics_storage': analytics ? 'granted' : 'denied',
    'ad_storage': advertising ? 'granted' : 'denied',
    'ad_user_data': advertising ? 'granted' : 'denied',
    'ad_personalization': advertising ? 'granted' : 'denied',
    'personalization_storage': advertising ? 'granted' : 'denied'
  });
  
  // Отправляем событие в dataLayer для триггеров
  window.dataLayer.push({
    'event': analytics && advertising ? 'consent_given' : 
             (!analytics && !advertising ? 'consent_rejected' : 'consent_updated'),
    'consentStatus': analytics && advertising ? 'granted' : 
                     (!analytics && !advertising ? 'denied' : 'partial'),
    'analyticsConsent': analytics ? 'granted' : 'denied',
    'adsConsent': advertising ? 'granted' : 'denied'
  });
  
  return true;
};

/**
 * Применяет сохраненные настройки согласия после загрузки GTM
 */
export const applyStoredConsent = () => {
  if (!hasUserMadeChoice()) return;
  
  // Даем GTM небольшое время на инициализацию
  setTimeout(() => {
    if (isGTMReady()) {
      const analytics = hasConsent('analytics');
      const advertising = hasConsent('advertising');
      
      console.log('[GTM] Applying stored consent:', { analytics, advertising });
      updateConsentState(analytics, advertising);
    }
  }, 500);
};